export default __webpack_public_path__ + "static/media/9Thales.ebf2142d.svg";